import { useFlags } from 'launchdarkly-react-client-sdk';

type FlagsRecord = Record<string, unknown>;

export const FEATURE_FLAGS = {
  CUSTOM_CONTENT_ENABLED: 'customContentEnabled',
  CUSTOM_CONTENT_ENABLED_M3: 'customContentEnabledM3',
  SKILL_DIVE_COLLECTIONS_IN_PLAYLISTS: 'skillDiveCollectionsInPlaylists',
} as const;

const toBooleanFlag = (value: unknown, fallback = false): boolean => {
  return typeof value === 'boolean' ? value : fallback;
};

export const useBooleanFlag = (flagName: string, fallback = false): boolean => {
  const flags = useFlags() as FlagsRecord | undefined;
  return toBooleanFlag(flags?.[flagName], fallback);
};
